import Image from 'next/image';

import { Button } from '@air/primitive-button';
import { Modal, ModalCloseButton } from '@air/primitive-modal';

import image from '~/assets/out_of_storage_background.png';

export const OutOfStorageModal = ({ onClose }: AirModalProps) => (
  <Modal isOpen onDismiss={onClose}>
    <header className="mb-6 flex items-center justify-end">
      <ModalCloseButton className="shrink-0" onClick={onClose} />
    </header>

    <div className="flex flex-col items-center justify-center">
      <Image src={image} alt="Out of storage" width={200} height={200} className="object-cover" />

      <p className="my-4 font-semibold ads:text-primary text-24 text-gray-12">This workspace is out of storage.</p>

      <p className="mb-8 text-center ads:text-primary text-16 text-gray-12">
        Contact the owner of this board so they can add more storage to their workspace.
      </p>

      <Button size="large" appearance="filled" color="blue" onClick={onClose}>
        Ok, got it
      </Button>
    </div>
  </Modal>
);
